import { Component, OnInit, Input, ElementRef, SimpleChanges } from '@angular/core';
import { Banner } from '../../shared/models/banner';
import { WindowService } from '../../services/window/window.service';
import { ScreenUtils } from '../../utils/screen.utils';
import {StaticValuesUtils} from '../../utils/static-values/static-values.utils';
import {AppSettingsService} from '../../services/app-settings/app-settings.service';

@Component({
  selector: 'peggy-banner',
  templateUrl: './peggy-banner.component.html',
  styleUrls: ['./peggy-banner.component.scss'],
})
export class PeggyBannerComponent implements OnInit {
  @Input() bannerData: Banner;

  constructor(private windowService: WindowService,
              private elRef: ElementRef,
              private appSettingsService: AppSettingsService) {}

  ngOnInit() {
    this.initializeBanner();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bannerData'] && !changes['bannerData'].firstChange) {
      this.initializeBanner();
    }
  }

  private initializeBanner(): void {
    const target = this.elRef.nativeElement.querySelector('div');
    try {
      const trackingData = {
        ...this.bannerData.data.draperContext,
        ...{
          xClient: this.appSettingsService.getAppName(),
          tcli: 'shopping-ds-it',
          ref: this.windowService.getHref(),
          pageview_id: StaticValuesUtils.getPageViewId()
        },
      };

      let meta = { tracking_data: trackingData, is_mobile: ScreenUtils.isMobile() };

      const banner = this.windowService.getPeggy().createBanner(this.bannerData.data, target, meta);
      banner.mount();
    } catch (e) {
      console.log('ERROR: BannerService Peggy banner mount failed', e);
    }
  }
}
